import React from 'react';
import { FaStar } from 'react-icons/fa';

const SubscriptionsInfoPage = () => {
  return (
    <div className="px-4 md:px-10">
      {/* Title and Description */}
      <div className="text-center mb-12">
        <h2 className="text-3xl font-bold text-gray-900 pt-12">Please Subscribe to Activate Your Account</h2>
        <p className="text-lg text-gray-600 mt-2">Choose a subscription plan to access all features</p>
      </div>

      {/* Subscription Plan Cards */}
      <div className="flex flex-wrap justify-center gap-12 mt-10">
        {/* Basic Plan Card */}
        <div className="relative w-full max-w-xs md:max-w-sm lg:max-w-md h-auto bg-[#e3defc] rounded-lg shadow-lg overflow-hidden flex flex-col justify-between items-center p-4 transition-transform transform hover:scale-105 hover:shadow-2xl duration-300">
          <div className="absolute top-0 left-0 w-48 h-48 bg-white rounded-full blur-3xl -translate-x-16 translate-y-8"></div>
          {/* Star Rating */}
          <div className="flex justify-center items-center mt-2 mb-2">
            {[...Array(2)].map((_, index) => (
              <FaStar
                key={index}
                className={`text-yellow-400 ${index < 3 ? "fill-current" : "text-gray-300"}`}
              />
            ))}
          </div>
          <div className="text-lg font-bold text-black text-center">BASIC</div>
          <div className="text-xl font-bold text-[#475be8] text-center">₹ 1,499</div>
          <div className="mt-4 text-black text-sm leading-relaxed text-center">
            ✔ Access to basic features
            <br />
            ✔ Limited email support
            <br />
            ✔ Monthly newsletters
            <br />
            ✔ Create up to 3 projects
            <br />
            ✔ Basic analytics
          </div>

          {/* Button inside card (moved below features) */}
          <div className="font-medium bg-[#475be8] text-white px-6 py-2 rounded cursor-pointer text-center transition-all duration-300 hover:bg-[#3e4db0] mt-6">
            Subscribe & Activate
          </div>
        </div>

        {/* Standard Plan Card */}
        <div className="relative w-full max-w-xs md:max-w-sm lg:max-w-md h-auto bg-[#fbd8aa] rounded-lg shadow-lg overflow-hidden flex flex-col justify-between items-center p-4 transition-transform transform hover:scale-105 hover:shadow-2xl duration-300">
          <div className="absolute top-0 left-0 w-48 h-48 bg-[#475be8]/35 rounded-full blur-3xl -translate-x-16 translate-y-2"></div>
          {/* Star Rating */}
          <div className="flex justify-center items-center mt-2 mb-2">
            {[...Array(4)].map((_, index) => (
              <FaStar
                key={index}
                className={`text-yellow-400 ${index < 4 ? "fill-current" : "text-gray-300"}`}
              />
            ))}
          </div>
          <div className="text-lg font-bold text-black text-center">STANDARD</div>
          <div className="text-xl font-bold text-black text-center">₹ 2,999</div>
          <div className="mt-4 text-black text-sm leading-relaxed text-center">
            ✔ Everything in Basic Plan
            <br />
            ✔ Advanced analytics
            <br />
            ✔ Priority email support
            <br />
            ✔ Create up to 10 projects
            <br />
            ✔ Monthly webinars
          </div>

          {/* Button inside card (moved below features) */}
          <div className="font-medium bg-[#e8973f] text-white px-6 py-2 rounded cursor-pointer text-center transition-all duration-300 hover:bg-[#cf7a2b] mt-6">
            Subscribe & Activate
          </div>
        </div>

        {/* Enterprise Plan Card */}
        <div className="relative w-full max-w-xs md:max-w-sm lg:max-w-md h-auto bg-[#475be8] rounded-lg shadow-lg overflow-hidden flex flex-col justify-between items-center p-4 transition-transform transform hover:scale-105 hover:shadow-2xl duration-300">
          <div className="absolute top-0 left-0 w-48 h-48 bg-[#e8973f]/70 rounded-full blur-3xl -translate-x-16 translate-y-2"></div>
          {/* Star Rating */}
          <div className="flex justify-center items-center mt-2 mb-2">
            {[...Array(6)].map((_, index) => (
              <FaStar
                key={index}
                className={`text-yellow-400 ${index < 5 ? "fill-current" : "text-gray-300"}`}
              />
            ))}
          </div>
          <div className="text-xl font-bold text-white text-center">ENTERPRISE</div>
          <div className="text-2xl font-bold text-white text-center">₹ 5,000</div>
          <div className="mt-4 text-white text-sm leading-relaxed text-center">
            ✔ Everything in Standard Plan
            <br />
            ✔ Dedicated account manager
            <br />
            ✔ Unlimited projects
            <br />
            ✔ Customizable features
          </div>

          {/* Button inside card (moved below features) */}
          <div className="font-medium bg-white text-[#6c63ff] px-6 py-2 rounded cursor-pointer text-center transition-all duration-300 hover:bg-[#e3e0ff] mt-6">
            Subscribe & Activate
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionsInfoPage;
